import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  IconButton,
  Paper,
  Stack,
  Typography,
  Grid,
  Box,
  TextField as MuiTextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, request, toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
const TABLE_COLUMNS = [
  {
    header: 'Diagnosis',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.diagnosis}`}
        </span>
      );
    }
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialDiagnosisDataObj = {
  data: [],
  loading: false
};

export const DiagnosisMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [diagnosisDataObj, setDiagnosisDataObj] = useState(initialDiagnosisDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [diagnosisGroupDropdown, setDiagnosisGroupDropdown] = useState([]);
  const [diagnosisSubGroupDropdown, setDiagnosisSubGroupDropdown] = useState([]);
  const [input, setInput] = useState('');
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        diagnosis: Yup.string().required('Diagnosis is required'),
        icd_version: Yup.string().required('ICD Version is required'),
        icd_chapter: Yup.string().required('ICD Chapter is required'),
        icd_code: Yup.string().required('ICD Code is required'),
        icd_group: Yup.string().required('ICD Group is required'),
        icd_subgroup: Yup.string().required('ICD Sub Group is required')
      })
    ),
    defaultValues: { diagnosis: '', default: false },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('diagnosis', selectedRecord.diagnosis);
      setValue('icd_version', selectedRecord.icd_version);
      setValue('icd_chapter', selectedRecord.icd_chapter);
      setValue('icd_code', selectedRecord.icd_code);
      setValue('icd_group', selectedRecord.icd_group);
      setValue('icd_subgroup', selectedRecord.icd_subgroup);
      setValue('default', selectedRecord.status === 'default');
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const getGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('diagnosis-group');
    setDiagnosisGroupDropdown(data);
  }, []);

  const getSubGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('diagnosis-subgroup');
    setDiagnosisSubGroupDropdown(data);
  }, []);

  useEffect(() => {
    getGroupDropdown();
    getSubGroupDropdown();
  }, [getGroupDropdown, getSubGroupDropdown]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/mrd-diagnosis-update' : '/mrd-diagnosis-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        icd_version: formValues.icd_version,
        icd_chapter: formValues.icd_chapter,
        icd_code: formValues.icd_code,
        icd_group: formValues.icd_group,
        icd_subgroup: formValues.icd_subgroup,
        diagnosis: formValues.diagnosis,
        status: formValues.default ? 'default' : 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Diagnosis master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Diagnosis master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/mrd-diagnosis-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Dignaosis master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Diagnosis master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/mrd-diagnosis-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Diagnosis master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Diagnosis master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDiagnosisDataObj({ loading: true });
    const response = await axios.get(`${BASE_URL}/mrd-diagnosis/list?limit=${10}`);
    if (response.data.success) {
      setDiagnosisDataObj({ loading: false, data: response.data?.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDiagnosisDataObj({ loading: false });
    }
  };

  useEffect(() => {
    handleDiagnosisSearch();
  }, [input]);

  const handleDiagnosisSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    
      try {
        const response = await request('/mrd-diagnosis-list', {
          method: 'GET',
          query: { name: lowercasedInput }
        });
        if (response.success && Array.isArray(response.data)) {
          setDiagnosisDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setDiagnosisDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setDiagnosisDataObj({ loading: false, data: [] });
      }
  
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Diagnosis Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                  id={`${lastPathSegment}Write`}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, justifyContent: 'space-around' }}
                >
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICD Version</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                          name="icd_version"
                          placeholder="ICD Version"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICD Chapter</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                          name="icd_chapter"
                          placeholder="ICD Chapter"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICD Code</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                          name="icd_code"
                          placeholder="ICD Code"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICD Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          menus={diagnosisGroupDropdown.map((data) => ({ ...data, name: data.diagnosis_group }))}
                          name="icd_group"
                          placeholder="ICD Group"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>ICD Sub Group</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                          name="icd_subgroup"
                          menus={diagnosisSubGroupDropdown.map((data) => ({ ...data, name: data.diagnosis_subgroup }))}
                          placeholder="ICD Sub Group"
                        />
                      </Stack>

                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Diagnosis Name</Typography>
                        <TextField
                          name="diagnosis"
                          sx={{ flex: 0.8, border: currentAction, border: currentAction ? '0.5px solid red' : '' }}
                          inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                          placeholder="Enter Diagnosis Name"
                          fullWidth
                          disabled={!['new', 'edit'].includes(currentAction)}
                        />
                      </Stack>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Diagnosis Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Diagnosis"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={diagnosisDataObj.data || []}
          loading={diagnosisDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
